<template>
  <img
    v-if="avatarUrl"
    class="inline-block rounded-full"
    :src="avatarUrl"
    alt="picture of the user"
  />
  <Avatar42 v-else class="inline-block rounded-full text-primary" />
</template>

<script setup lang="ts">
import Avatar42 from '~/components/icons/shape.so/boxed/Avatar42.vue'

defineProps<{
  avatarUrl?: string
}>()
</script>
